import React from 'react';
import './index.scss';
import nativeInterface from '../../../../../../native-interact/native';

function Uploadimg(props) {
  const {
    picType,
    picurl,
    handleUpload
  } = props;


  const takePhoto = () => {
    handleUpload({
      picType,
      picurl: `pciurl${picType}`
    });
    nativeInterface.capture();
  };

  return (
    <div className="upload-content" onClick={takePhoto}>
      {
        picurl
          ? (
            <div className="upload-img">
              <img src={picurl} alt="" />
            </div>
          )
          : (
            <div className="upload">+</div>
          )
      }
    </div>
  );
}

export default Uploadimg;
